module.exports = __webpack_public_path__ + "static/sav.banner-mosaic-malhas-strass-d89d4fe5955ff2371d8329bc879b3d82.jpg";